export default __webpack_public_path__ + "3672264812746c3c7225909742da535c.woff";